<template>
    <div> 
        <h1 class="mb-4 font-active">Free Ring Resize</h1>
        <p>
            If you have ordered the wrong ring size, we have got you covered! Friendly Diamonds India offers you one Complimentary Ring Resize within the first 12 months of your purchase. If your order qualifies for the complimentary ring resizing, we offer free shipping both ways for all orders.
            <br><br>
            If your ring is more than a year old or requires a second (or more) resize, a fee of ₹2500 will be charged for resizing the ring. For such resizes, the actual shipping costs for both-way shipments will be charged to you.
        </p>
        <h3>Ring Resizing Terms</h3>
        <p>
            Our <router-link :to="localePath('/customer-service/ring-resizing')">ring resizing</router-link> policy allows for complimentary resizes up to 2 sizes above or below the ring’s original size. If a resize beyond this range is necessary, we may provide you with an additional quote or depending on the design, recommend purchasing a completely new ring.
            <br><br>
            It's important to note that resizing engraved rings may alter the appearance of the engravings and the characters may appear different and less legible. You can choose to have the ring re-inscribed after resizing for a fee of ₹1500 (for up to 20 characters). Please refer to our ring engraving policy for more details. 
        </p>
        <h3>Rings That Cannot Be Resized</h3>
        <p>Certain rings, such as eternity rings, full eternity  <router-link :to="localePath({ name:'cyo-setting-list-ring'})">engagement ring settings</router-link> and full eternity wedding and matching bands cannot be resized due to their specific design. In such cases, purchasing a new ring is the recommended solution.</p>

        <h3>Shipping Terms for Resized Items</h3>
        <p>All resized items are typically shipped within 7-10 business days from the date of receiving the item. In case we need to remake the product, it can take up to 2 weeks.</p>
    </div>
</template>

<script setup>
    const localePath = useLocalePath()
</script>

<style scoped>
.main_title {
    margin: 4% 0;
}
.main_title h2 {
    font-size: 40px;
    text-align: center;
}
h1{
    font-size: 32px;
    text-transform: capitalize;
}
p {
    margin-bottom: 0;
    color: #606060;
    font-size: 16px;
    font-weight: 500;
}
ul {
    margin-left: 25px;
    padding-left: 0;
}
ul li{
    color: #606060;
    font-size: 16px;
    font-weight: 500; 
}
h3, h2 {
    font-size: 21px;
    font-weight: 500;
    margin: 30px 0 20px;
}
h4{
    margin-bottom: 6px;
    color: #353535;
    font-size: 16px;
    font-weight: 600;
    line-height: 1.5;
}
a{
    color: var(--green);
    text-decoration: underline;
}


@media(max-width: 767px){
    .main_title h2{
        font-size: 32px;
    }
    .main_title {
        margin: 13% 0 10%;
    }
    h1{
        font-size: 20px;
    }
    h3, h2{
        font-size: 18px;
    }
    p{
        font-size: 14px;
    }

    ul li {
        font-size: 14px;
    }
}
</style>